<page-toolbar title="{{ 'pages.notifications' | translate }}"></page-toolbar>
<page-content [noPadding]="true">

  <div class="container">
    <div class="dynamic-data" [class.detail]="!!currentItem">
      <div class="dynamic-data-content">
        <div class="header">
          <div class="title"></div>

          <div class="actions">
            <button (click)="add()" matTooltip="{{'dynamicContent.addEntry' | translate}}" matTooltipPosition="left">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>

        <div class="sub-header">
          <div class="title">Titel</div>
          <div class="send-date">Versand</div>
          <div class="created">{{ 'general.created' | translate }}</div>
          <div class="actions"></div>
        </div>

        <div *ngIf="!!data?.length" class="list">
          <div *ngFor="let item of data" class="item" (click)="edit(item, $event)">
            <div class="title"><span>{{item.title}}</span></div>
            <div class="send-date">
              <div class="chip {{!!item.sent ? 'sent' : 'planned'}}">{{ !!item.sent ? 'Gesendet' : 'Geplant' }}</div>
              {{ getSendState(item) }}
            </div>
            <div class="created" *ngIf="!!item?.created">{{item?.created | date:'dd.MM.YYYY'}}</div>
            <div class="actions">
              <button (click)="edit(item, $event)"><mat-icon>{{!!item.sent ? 'bar_chart' : 'edit'}}</mat-icon></button>
              <button *ngIf="!item.sent" (click)="remove(item, $event)"><mat-icon>delete</mat-icon></button>
            </div>
          </div>
        </div>
        <div class="empty" *ngIf="!data?.length">{{ 'dynamicContent.noEntries' | translate }}</div>
      </div>
    </div>

    <div class="detail" *ngIf="currentItem">
      <notification-form *ngIf="!currentItem?.sent" [notification]="currentItem" [packageId]="packageId" (saved)="getData()" [pak]="pak"
                         (close)="currentItem = null; getData()"></notification-form>
      <notification-statistics *ngIf="!!currentItem?.sent" [notification]="currentItem" [packageId]="packageId" (close)="currentItem = null" [pak]="pak"></notification-statistics>
    </div>
  </div>
</page-content>
